"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityEventsEnum = exports.SchemaChecks = exports.EldHosClocksSchemaEnum_1 = exports.OutOfOfficeSchemaEnum_1 = exports.ActivationEnum = exports.ReplyContextStatus = exports.DeviceNotifyForEnum = exports.ChannelTypeEnum = exports.CommsContext = exports.CommsMedium = exports.LastActionType = exports.SubscriptionStatus = exports.ResourceTypes = void 0;
var ResourceTypes;
(function (ResourceTypes) {
    ResourceTypes["ACTIVITIES"] = "activities";
    ResourceTypes["AGENTS_CONFIGURATIONS"] = "agents--configurations";
    ResourceTypes["BROADCASTS"] = "broadcasts";
    ResourceTypes["BROADCASTS_TARGETS"] = "broadcasts--targets";
    ResourceTypes["CHANNELS"] = "channels";
    ResourceTypes["CURSORS"] = "cursors";
    ResourceTypes["DEVICES"] = "devices";
    ResourceTypes["DOCUMENTS"] = "documents";
    ResourceTypes["ENDPOINTS"] = "endpoints";
    ResourceTypes["IDENTITIES"] = "identities";
    ResourceTypes["MESSAGES"] = "messages";
    ResourceTypes["ORG_WHITELABEL"] = "organizations-whitelabel";
    ResourceTypes["ORGANIZATIONS"] = "organizations";
    ResourceTypes["PEOPLE"] = "people";
    ResourceTypes["REPLY_CONTEXTS"] = "replyContexts";
    ResourceTypes["SUBSCRIPTIONS"] = "subscriptions";
    ResourceTypes["SUBSCRIPTIONS_INVITATIONS"] = "subscriptions-invitations";
    ResourceTypes["TENANTS"] = "tenants";
    ResourceTypes["TENANTS_ENDPOINTS_ADDRESSES"] = "tenants--endpoints--addresses";
    ResourceTypes["THREADS"] = "threads";
    ResourceTypes["TWILIO_INTEGRATION"] = "3p_int_twilio";
    ResourceTypes["USAGE_RECORDS"] = "usageRecords";
    ResourceTypes["VENDOR_GROUPS"] = "vendorGroups";
})(ResourceTypes = exports.ResourceTypes || (exports.ResourceTypes = {}));
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["PENDING"] = "PENDING";
    SubscriptionStatus["OK"] = "OK";
    SubscriptionStatus["BLOCKED"] = "BLOCKED";
})(SubscriptionStatus = exports.SubscriptionStatus || (exports.SubscriptionStatus = {}));
var LastActionType;
(function (LastActionType) {
    LastActionType["NONE"] = "NONE";
    LastActionType["INVITED"] = "INVITED";
    LastActionType["APPROVED"] = "APPROVED";
    LastActionType["BLOCKED"] = "BLOCKED";
})(LastActionType = exports.LastActionType || (exports.LastActionType = {}));
var CommsMedium;
(function (CommsMedium) {
    CommsMedium["EMAIL"] = "EMAIL";
    CommsMedium["SMS"] = "SMS";
    CommsMedium["TELEPHONE"] = "TELEPHONE";
})(CommsMedium = exports.CommsMedium || (exports.CommsMedium = {}));
var CommsContext;
(function (CommsContext) {
    CommsContext["MOBILE"] = "MOBILE";
    CommsContext["WORK"] = "WORK";
    CommsContext["HOME"] = "HOME";
    CommsContext["OTHER"] = "OTHER";
})(CommsContext = exports.CommsContext || (exports.CommsContext = {}));
var ChannelTypeEnum;
(function (ChannelTypeEnum) {
    ChannelTypeEnum["STANDARD"] = "STANDARD";
    ChannelTypeEnum["CAPTIVE_THREAD"] = "CAPTIVE_THREAD";
})(ChannelTypeEnum = exports.ChannelTypeEnum || (exports.ChannelTypeEnum = {}));
/** @deprecated */
var DeviceNotifyForEnum;
(function (DeviceNotifyForEnum) {
    DeviceNotifyForEnum["ALL_MESSAGES"] = "ALL_MESSAGES";
    DeviceNotifyForEnum["MESSAGE__ORGANIZATIONS__BELONGS_TO"] = "message:organizations/belongsTo";
    DeviceNotifyForEnum["MESSAGE__CONTACT_GROUPS__WATCHING"] = "message:contactGroups/watching";
})(DeviceNotifyForEnum = exports.DeviceNotifyForEnum || (exports.DeviceNotifyForEnum = {}));
var ReplyContextStatus;
(function (ReplyContextStatus) {
    ReplyContextStatus["UNREAD"] = "UNREAD";
    ReplyContextStatus["READ"] = "READ";
    ReplyContextStatus["IN_PROGRESS"] = "IN_PROGRESS";
    ReplyContextStatus["COMPLETED"] = "COMPLETED";
})(ReplyContextStatus = exports.ReplyContextStatus || (exports.ReplyContextStatus = {}));
var ActivationEnum;
(function (ActivationEnum) {
    ActivationEnum["ALWAYS"] = "ALWAYS";
    ActivationEnum["ON_SCHEDULE"] = "ON_SCHEDULE";
    ActivationEnum["NEVER"] = "NEVER";
})(ActivationEnum = exports.ActivationEnum || (exports.ActivationEnum = {}));
var OutOfOfficeSchemaEnum_1;
(function (OutOfOfficeSchemaEnum_1) {
    OutOfOfficeSchemaEnum_1["DEV"] = "https://switchboard.dev.vendorflow.co/foundry/v0/agents/vf:OutOfOffice/schemas/1";
    OutOfOfficeSchemaEnum_1["PROD"] = "https://switchboard.vendorflow.co/foundry/v0/agents/vf:OutOfOffice/schemas/1";
})(OutOfOfficeSchemaEnum_1 = exports.OutOfOfficeSchemaEnum_1 || (exports.OutOfOfficeSchemaEnum_1 = {}));
var EldHosClocksSchemaEnum_1;
(function (EldHosClocksSchemaEnum_1) {
    EldHosClocksSchemaEnum_1["DEV"] = "https://switchboard.dev.vendorflow.co/foundry/v0/agents/vf:EldHosClocks/schemas/1";
    EldHosClocksSchemaEnum_1["PROD"] = "https://switchboard.vendorflow.co/foundry/v0/agents/vf:EldHosClocks/schemas/1";
})(EldHosClocksSchemaEnum_1 = exports.EldHosClocksSchemaEnum_1 || (exports.EldHosClocksSchemaEnum_1 = {}));
exports.SchemaChecks = {
    isOutOfOfficeSchema_1: function (config) {
        return config.schema === OutOfOfficeSchemaEnum_1.DEV || config.schema === OutOfOfficeSchemaEnum_1.PROD;
    },
    isEldHosClocksSchema_1: function (config) {
        return config.schema === EldHosClocksSchemaEnum_1.DEV || config.schema === EldHosClocksSchemaEnum_1.PROD;
    },
};
var ActivityEventsEnum;
(function (ActivityEventsEnum) {
    ActivityEventsEnum["MENTION"] = "MENTION";
})(ActivityEventsEnum = exports.ActivityEventsEnum || (exports.ActivityEventsEnum = {}));
